import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router';
import { WorkspaceIcon } from '@/components/workspace/WorkspaceIcon';

/**
 * Каркас неавторизованных страниц (вход, регистрация, приглашение, восстановление) по
 * макету: слева история продукта с логотипом-ссылкой, справа форма страницы. Ссылка
 * «назад» в углу колонки формы в макете демонстрационная («Вернуться к макету»), её нет.
 */
export function GuestLayout() {
	const { t } = useTranslation('auth');
	return (
		<div className="ws-auth-layout">
			<aside className="ws-auth-story" aria-label={t('guest.storyLabel')}>
				<Link className="ws-auth-brand" to="/overview">
					quantum<strong>hash</strong>
				</Link>
				<span className="ws-auth-eyebrow">{t('guest.eyebrow')}</span>
				<div className="ws-auth-message">
					<span className="ws-eyebrow-label">{t('guest.motto')}</span>
					<h2>
						{t('guest.titleLine1')}
						<br />
						{t('guest.titleLine2')}
					</h2>
					<p>{t('guest.text')}</p>
					<div className="ws-auth-orbit" aria-hidden="true">
						<span>
							<WorkspaceIcon name="box" size={26} />
						</span>
						<i />
						<span>
							<WorkspaceIcon name="shield" size={32} />
						</span>
						<i />
						<span>
							<WorkspaceIcon name="database" size={26} />
						</span>
					</div>
				</div>
				<small>{t('guest.footer')}</small>
			</aside>
			<main className="ws-auth-form">
				<div>
					<Outlet />
				</div>
			</main>
		</div>
	);
}
